module.exports = __webpack_public_path__ + "static/media/IM.3e276e7d.svg";